# Place all the behaviors and hooks related to the matching controller here.
# All this logic will automatically be available in application.js.
# You can use CoffeeScript in this file: http://jashkenas.github.com/coffee-script/


$(document).on 'turbolinks:load', ->
  $("#client_contract_terminate_at").datetimepicker({timeFormat: 'HH:mm', language: 'cs-CZ', dateFormat: "yy-mm-dd"})

  $all_modal = $('#sms-all-modal')
  $('.print-btn').click ->
    $('.print-btn').hide()
    window.print()
    $('.print-btn').show()
    return
  
  $modal_sms = $('#sms-modal')
  $('#btn-send-sms').click ->
    $modal_sms.modal('hide')
    return
    
  $modal_email = $('#email-modal')
  $('#btn-send-email').click ->
    $modal_email.modal('hide')
    return
  
  $('#btn-cancel-sms').click ->
    $modal_sms.modal('hide')
    $modal_sms.find('#client-name').html('')
    $modal_sms.find('#client_id').val('')
    return

  $('#btn-cancel-email').click ->
    $modal_email.modal('hide')
    $modal_email.find('#client-name').html('')
    $modal_email.find('#client_id').val('')
    return

  $('.btn-sms').click ->
    $modal_sms.modal('show')
    client_id = $(this).closest('.btn-sms').data('client-id')
    client_name = $(this).closest('.btn-sms').data('client-name')
    $modal_sms.find('#client-name').html("Text message to " + client_name)
    $modal_sms.find('#client_id').val(client_id)

  $('.btn-email').click ->
    $modal_email.modal('show')
    client_id = $(this).closest('.btn-email').data('client-id')
    client_name = $(this).closest('.btn-email').data('client-name')
    $modal_email.find('#client-name').html("Text message to " + client_name)
    $modal_email.find('#client_id').val(client_id)
  
  $('#btn-send-sms-all').click ->
    $all_modal.modal('hide')
    return
  $('#btn-cancel-sms-all').click ->
    $all_modal.modal('hide')
    return
  $('.btn-sms-all').click ->
    $all_modal.modal('show')
    return
  return
